.block-editable-text {
  width: 100%;
}

.block-name {
  width: 100%;
  height: 3.2rem;
  padding: 0.8rem;
  text-align: center;
}
